import * as api from "../../services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import {
  fetchStatistics,
  updateStatistics,
} from "../../services/statistics.service";
import { RootState } from "../store";
import { StatisticsResponse } from "../config";

export const doFetchStatistics = createAsyncThunk(
  "statistics/fetchStatistics",
  async (_) => {
    try {
      const response: any = await fetchStatistics();
      return response.data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch Statistics";
      enqueueSnackbar(errorMessage, { variant: "error" });
      throw errorMessage;
    }
  }
);

export const doUpdateStatistics = createAsyncThunk(
  "stats/updateStatistics",
  async (
    updatedData: Partial<StatisticsResponse["data"]>,
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState() as RootState;
      const id = state.stats.data?.statisticsUid;
      if (!id) {
        throw new Error("Statistics ID not found");
      }

      const response: any = await updateStatistics(id, updatedData);
      return response.data;
    } catch (error: any) {
      enqueueSnackbar(
        error.response?.data?.message || "Failed to update statistics",
        {
          variant: "error",
        }
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to update statistics"
      );
    }
  }
);
